<template>
  <div>
    <div class="grid">
      <div class="grid-title">
        <div class="row">
          <div class="col-md-6">
            <h4>Fabric Image Review</h4>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <v-select
              class="fabric-selector"
              placeholder="Select Page"
              @input="(page) => (selectedPage = page)"
              :reduce="(page) => page.key"
              :clearable="false"
              :value="selectedPage"
              :options="pages"
            >
            </v-select>
          </div>
          <div class="col-md-6">
            <v-select
              multiple
              class="fabric-selector"
              placeholder="Select Statuses"
              @input="(statuses) => (selectedStatuses = statuses)"
              :reduce="(status) => status.key"
              :value="selectedStatuses"
              :options="statuses"
            >
            </v-select>
          </div>
          <div class="col-md-3">
            <button v-if="isLoading" class="btn btn-primary disabled" disabled>
              <span class="fa fa-cog fa-spin"></span>
            </button>
            <button
              v-if="!isLoading"
              class="btn btn-primary"
              @click="checkFabricImagesForPage()"
            >
              Filter
            </button>
            <button class="btn btn-primary mb-2" @click="onExportPDF()">
              <span>
                <i class="fa fa-download" aria-hidden="true"></i>
                Export To Excel
              </span>
            </button>
          </div>
        </div>
      </div>

      <div class="grid-body">
        <div class="table-responsive" id="image-review">
          <vue-good-table
            max-height="600px"
            :fixed-header="true"
            mode="remote"
            ref="override_table"
            @on-page-change="onPageChange"
            @on-sort-change="onSortChange"
            @on-per-page-change="onPerPageChange"
            :totalRows="totalRecords"
            styleClass="table table-bordered"
            :pagination-options="{
              enabled: true,
              mode: 'pages',
            }"
            :columns="columns"
            :rows="results"
          >
            <template slot="table-row" slot-scope="props">
              <span
                v-if="
                  ['id', 'name', 'status', 'future'].indexOf(
                    props.column.field
                  ) == -1
                "
              >
                <span
                  class="fa fa-check-circle fa-2x text-info"
                  v-if="props.row[props.column.field] == 'Y'"
                ></span>
                <span
                  class="fa fa-times-circle fa-2x text-danger"
                  v-if="props.row[props.column.field] == 'N'"
                ></span>
              </span>
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
          </vue-good-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VueGoodTable } from "vue-good-table";
export default {
  components: {
    VueGoodTable,
  },
  data() {
    return {
      isLoading: false,
      results: [],
      selectedPage: "fabric_explorer_page",
      pages: [
        { key: "fabric_explorer_page", label: "Fabric Explorer Page" },
        {
          key: "fabric_explorer_page_popup",
          label: "Fabric Explorer Page Popup",
        },
        { key: "consultant_shop", label: "Consultant Shop" },
        { key: "client_shop", label: "Client Shop" },
        { key: "fabric_qr_page", label: "Fabric QR Page" },
        { key: "fabric_book", label: "Fabric Book" },
        { key: "3d_konfigurator", label: "3D Konfigurator" },
      ],
      selectedStatuses: [
        "available",
        "soon_sold_out_coming_back",
        "soon_sold_out_not_coming_back",
      ],
      statuses: [
        { key: "available", label: "Available" },
        {
          key: "soon_sold_out_coming_back",
          label: "Soon Sold Out (Coming Back)",
        },
        {
          key: "soon_sold_out_not_coming_back",
          label: "Soon Sold Out (Not Coming Back)",
        },
        { key: "sold_out_coming_back", label: "Sold Out (Coming Back)" },
        {
          key: "sold_out_not_coming_back",
          label: "Sold Out (Not Coming Back)",
        },
        { key: "inactive", label: "Inactive" },
        { key: "not_released_yet", label: "Not Released Yet" },
      ],
      totalRecords: 0,
      serverParams: {
        page: 1,
        perPage: 10,
        orderBy: { column: "name", type: "asc" },
      },
      columns: [],
    };
  },

  mounted() {
    this.checkFabricImagesForPage();
  },

  methods: {
    async checkFabricImagesForPage() {
      let params = {
        page: this.selectedPage,
        statuses:
          this.selectedStatuses.length > 0 ? this.selectedStatuses : ["all"],
        paginationPage: this.serverParams.page,
        perPage: this.serverParams.perPage,
        orderBy: this.serverParams.orderBy,
      };
      this.isLoading = true;
      try {
        let results = await axios({
          method: "get",
          url: "/v2/fabrics/images/review",
          params: params,
        });
        this.columns = await this.setColumns(results.data.data.headers);
        this.totalRecords = results.data.data.total;
        this.results = results.data.data.rows;
        this.isLoading = false;
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        }
      }
    },

    async setColumns(columnData) {
      let cols = [];
      return new Promise((resolve, reject) => {
        columnData.map((column) => {
          cols.push({
            label: column,
            field: column,
            tdClass: "text-left",
            thClass: "text-left",
          });
        });
        resolve(cols);
      });
    },

    updateParams(params) {
      /**
       * Force the 3rd click to behave like the first click in the vue-good-table plugin
       * @see https://github.com/xaksis/vue-good-table/issues/794
       */
      if (params.orderBy && params.orderBy.type === "none") {
        params.orderBy.type =
          this.serverParams.orderBy.type === "asc" ? "desc" : "asc";
        this.$refs.override_table.sorts.map((sort, index) => {
          if (sort.field === params.orderBy.column) {
            this.$refs.override_table.sorts[index].type = params.orderBy.type;
          }
        });
      }
      this.serverParams = Object.assign({}, this.serverParams, params);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.checkFabricImagesForPage();
    },

    onSortChange(params) {
      this.updateParams({
        page: 1,
        orderBy: {
          type: params[0].type,
          column: params[0].field,
        },
      });
      this.checkFabricImagesForPage();
    },

    onPerPageChange(params) {
      this.updateParams({ page: 1, perPage: params.currentPerPage });
      this.checkFabricImagesForPage();
    },

    async onExportPDF() {
      let params = {
        page: this.selectedPage,
        statuses: this.selectedStatuses,
      };
      if (await ezy.confirm("Are You Sure To Export?", "YES")) {
        try {
          const response = await axios.get("v2/fabrics/images/review/export", {
            params: params,
            responseType: "blob",
          });

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          let fileName = "fabricImageReview" + moment().format("YYYY-MM-DD");
          link.setAttribute("download", `${fileName}.xlsx`);
          document.body.appendChild(link);
          link.click();
        } catch (error) {
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          }
        }
      }
    },
  },
};
</script>

<style lang="scss">
#image-review.table-responsive {
  .vgt-responsive {
    overflow-y: scroll;
  }
  .vgt-fixed-header {
    max-width: 99%;
    overflow: hidden;
  }
  table {
    table-layout: fixed;
    max-width: none;
    width: 99%;
    overflow: hidden;
    border-collapse: separate !important; /* Don't collapse */
    border-spacing: 0 !important;
    word-wrap: break-word;
  }
  thead tr {
    position: sticky !important;
    top: 0;
    z-index: 1;
  }
}
</style>
